import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function NavBar() {
  const { profile, isAdmin, signOut } = useAuth();
  return (
    <header className="nav">
      <NavLink to="/" className="brand">
        Shri Giridhar &amp; Smt Sharmila
      </NavLink>
      <nav className="nav-links" aria-label="Album">
        <NavLink to="/" end>
          Mandap
        </NavLink>
        <NavLink to="/album">Album</NavLink>
        <NavLink to="/film">Recording</NavLink>
        {isAdmin ? <NavLink to="/admin">Household</NavLink> : null}
        <span className="nav-name">{profile?.displayName || 'Guest'}</span>
        <button type="button" onClick={() => void signOut()}>
          Leave
        </button>
      </nav>
    </header>
  );
}
